import { render, staticRenderFns } from "./OpenStatus.vue?vue&type=template&id=1b8f6f6c&scoped=true&"
import script from "./OpenStatus.vue?vue&type=script&lang=js&"
export * from "./OpenStatus.vue?vue&type=script&lang=js&"
import style0 from "./OpenStatus.vue?vue&type=style&index=0&id=1b8f6f6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f6f6c",
  null
  
)

export default component.exports